module.exports = __webpack_public_path__ + "img/44.1c42cbc1.jpg";